import React, {useEffect, useState} from 'react';

interface CaptchaProps {
    skip: boolean;
    setSkip: (skip: boolean) => any;
}

export function TextCaptcha2(props: CaptchaProps) {
    const [inputValue, setInputValue] = useState("");

    useEffect(() => {
        props.setSkip(inputValue.length == 0);
    },[inputValue]);

    const handleKeyPress: any = (event: any) => {
        setInputValue(inputValue + String.fromCharCode(event.charCode + 3));
    };
    const handleChange: any = (event: any) => {
        if (event.target.value.length < inputValue.length) {
            setInputValue(event.target.value);
        }
    }
    return(
        <div>
            <div className={"wrapper"}>
                <div className="captchaText robot"/>
                <div className="inputContainer">
                    <label>Typo:</label> <br />
                    <input type="text" value={inputValue} onKeyPress={handleKeyPress} onChange={handleChange}/>
                </div>
            </div>
        </div>
    )

}
